<div class="bina-catalog-item-edit">
  <div class="bina-catalog-item-edit__header">
    <div class="bina-catalog-item-edit__header-text">
      {{ "LABELS.EDIT_TITLE" | translate }}
    </div>
    <div class="bina-catalog-item-edit__header-close" (click)="close.emit()">×</div>
  </div>

  <div class="bina-catalog-item-edit__content">
    <div class="bina-catalog-item-edit__input-form">
      <form (ngSubmit)="onSave()">
        <label class="form-label bina-catalog-item-edit__label" for="titleControl">
          {{ "LABELS.PRODUCT_TITLE" | translate }}
        </label>
        <textarea
          #titleControlInput
          type="text"
          class="form-control bina-catalog-item-edit__input"
          id="titleControl"
          name="titleControl"
          control-wrapper
          [formControl]="titleControl"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [rows]="3"
          [mask]="'F{50}'"
          [maxMaskLength]="50"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          [maskSkipEnter]="true"
          (keydown)="saveInputPressKey($event)"
        ></textarea>

        <button type="submit" class="btn btn-primary bina-catalog-item-edit__input-button" [disabled]="!titleControl.value.length">
          {{ "BUTTON.SAVE" | translate | uppercase }}
        </button>
      </form>
    </div>
  </div>
</div>
